export const LISTADO_MENU = [
   {
      id: 0,
      nombre: 'Inicio',
      routerLink: '/inicio',
      children: [],
      visible: true
   },
   {
      id: 1,
      nombre: 'Estado de los recursos naturales',
      children: [
         {
            id: 1,
            nombre: 'Recurso Hídrico',
            routerLink: '/submenu',
            rep: 'Recurso Hídrico ',
            queryParams: 'Recurso Hídrico ',
            visible: true,
            children: [
               {
                  id: 2,
                  routerLink: '/tablero',
                  parentMenu: 'Recurso Hídrico ',
                  image: '../../../../../assets/images/lineas-trabajo/2.svg',
                  nombre: 'Planes de Ordenación y Manejo de Cuencas Hidrográficas - POMCA',
                  rep: 'POMCA',
                  queryParams: 'POMCA',
                  visible: true
               },
               {
                  id: 3,
                  routerLink: '/tablero',
                  parentMenu: 'Recurso Hídrico ',
                  image: '../../../../../assets/images/lineas-trabajo/3.svg',
                  nombre: 'Estudio nacional de AGUA - ENA',
                  rep: 'Estudio nacional de AGUA',
                  queryParams: 'Estudio nacional de AGUA',
                  visible: true
               }
            ]
         },
         {
            id: 2,
            routerLink: '/tablero',
            parentMenu: 'Deforestación ',
            image: '../../../../../assets/images/lineas-trabajo/5.svg',
            nombre: 'Deforestación',
            rep: 'Deforestación',
            queryParams: 'Deforestación',
            visible: true

         }, 
         {
            id: 3,
            routerLink: '/tablero',
            parentMenu: 'Estado de los recursos naturales',
            image: '../../../../../assets/images/lineas-trabajo/6.svg',
            nombre: 'Alertas tempranas',
            rep: 'Alertas tempranas',
            queryParams: 'Alertas tempranas',
            visible: true,
         },
      ],
      visible: true
   },
   {
      id: 2,
      nombre: 'Prioridades de gobierno',
      children: [
         {
            id: 1,
            routerLink: '/tablero',
            parentMenu: 'Prioridades de gobierno',
            image: '../../../../../assets/images/lineas-trabajo/5.svg',
            nombre: 'Contención de la deforestación',
            queryParams: 'Contención de la deforestación',
            rep: 'Contención de la deforestación',
            visible: true,
         },
         /* {
            id: 2,
            routerLink: '/tablero',
            parentMenu: 'Prioridades de gobierno',
            image: '../../../../../assets/images/lineas-trabajo/4.svg',
            nombre: 'Sentencia atrato',
            queryParams: 'Sentencia atrato',
            rep: 'Sentencia atrato',
            visible: true
         }, */
         /* {
            id: 3,
            routerLink: '/tablero',
            parentMenu: 'Prioridades de gobierno',
            nombre: 'Metas plan nacional de desarrollo',
            queryParams: 'Metas plan nacional de desarrollo',
            rep: 'Metas plan nacional de desarrollo',
            visible: true
         }, */
         {
            id: 4,
            routerLink: '/submenu',
            parentMenu: 'Prioridades de gobierno',
            image: '../../../../../assets/images/lineas-trabajo/2.svg',
            nombre: 'Ecorregiones',
            queryParams: 'Ecorregiones',
            rep: 'Ecorregiones',
            visible: true,
            children: [
               {
                  id: 1,
                  routerLink: '/tablero',
                  image: '../../../../../assets/images/lineas-trabajo/7.svg',
                  parentMenu: 'Ecorregiones',
                  nombre: 'Mapa de ecorregiones',
                  rep: 'Mapa de ecorregiones',
                  queryParams: 'Mapa de ecorregiones',
                  visible: true
               },
              /*  {
                  id: 2,
                  routerLink: '/tablero',
                  image: '../../../../../assets/images/lineas-trabajo/8.svg',
                  parentMenu: 'Ecorregiones',
                  nombre: 'Plan de acción y seguimiento a ecorregiones estratégicas',
                  rep: 'Plan de acción y seguimiento a ecorregiones estratégicas',
                  queryParams: 'Plan de acción y seguimiento a ecorregiones estratégicas',
                  visible: true
               } */

            ]
         },
         {
            id: 1,
            routerLink: '/tablero',
            parentMenu: 'Prioridades de gobierno',
            image: '../../../../../assets/images/lineas-trabajo/5.svg',
            nombre: 'Conservar paga',
            queryParams: 'Conservar paga',
            rep: 'Conservar paga',
            rol: 'Consulta Conservar paga',
            visible: true,
         },
      ],
      visible: true
   },
   {
      id: 3,
      nombre: 'Desempeño y gestión',
      rol: ['Consulta OCI', 'Consulta OAP'],
      children: [
         {
            id: 1,
            routerLink: '/submenu',
            nombre: 'Presupuesto',
            queryParams: 'Presupuesto',
            rep: 'Presupuesto',
            rol: 'Consulta OAP',
            visible: true,
            children: [
               {
                  id: 1,
                  routerLink: '/tablero',
                  parentMenu: 'Desempeño y gestión',
                  nombre: 'Ministerio',
                  rep: 'Ministerio',
                  queryParams: 'Ministerio',
                  rol: 'Consulta OAP',
                  visible: true
               },
               {
                  id: 2,
                  routerLink: '/tablero',
                  parentMenu: 'Desempeño y gestión',
                  nombre: 'Sector',
                  rep: 'Sector',
                  queryParams: 'Sector',
                  rol: 'Consulta OAP',
                  visible: true
               },
            ]
         },
         {
            id: 2,
            routerLink: '/tablero',
            nombre: 'Proyectos de inversión',
            queryParams: 'Proyectos de inversión',
            rep: 'Proyectos de inversión',
            rol: 'Consulta OAP',
            visible: true
         },
         {
            id: 3,
            routerLink: '/tablero',
            nombre: 'Control Interno',
            queryParams: 'Control Interno',
            rep: 'Control Interno',
            rol: 'Consulta OCI',
            visible: true
         },
      ],
      visible: true
   },
   
];